import OrderChart from './OrderChart';

export default OrderChart;
